{
  "文件不能为空": "The file must not be empty",
  "图片压缩失败，请重试": "Image compression failed. Please try again.",
  "文件不能超过 {{size}}": "The file must not exceed {{size}}",
  "JPG / PNG / WebP，最大 {{size}}": "JPG / PNG / WebP, up to {{size}}",
  "JPG / PNG / WebP": "JPG / PNG / WebP",
  "供需附件": "Listing attachment",
  "供需附件 #{{id}}": "Listing attachment #{{id}}",
  "系统配置 #{{id}}": "System configuration #{{id}}"
}
